export const _decrees = [
    {
        title: 'Decreto 1783 de 2021',
        contents: 'Por el cual se modifica parcialmente el Decreto 1077 de 2015 Único Reglamentario del Sector Vivienda, Ciudad y Territorio, en lo relacionado con el estudio, trámite y expedición de las licencias urbanísticas y se dictan otras disposiciones.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=175086'
    }, 
    {
        title: 'Decreto 1890 de 2021',
        contents: 'Por el cual se modifica parcialmente el Decreto 1077 de 2015 Único Reglamentarío del Sector Vivienda, Ciudad y Territorio, en lo relacionado con la reglamentación del artículo 49 de la Ley 1955 de 2019 sobre las expensas por trámites ante los curadores urbanos.',
        link: 'https://dapre.presidencia.gov.co/normativa/normativa/DECRETO%201890%20DEL%2030%20DE%20DICIEMBRE%20DE%202021.pdf'
    },
    {
        title: 'Decreto 1203 de 2017 ',
        contents: 'Por medio del cual se modifica parcialmente el Decreto 1077 de 2015 Único Reglamentario del Sector Vivienda, Ciudad y Territorio y se reglamenta la Ley 1796 de 2016, en lo relacionado con el estudio, trámite y expedición de las licencias urbanísticas y la función pública que desempeñan los curadores urbanos y se dictan otras disposiciones.',
        link: 'http://es.presidencia.gov.co/normativa/normativa/DECRETO%201203%20DEL%2012%20DE%20JULIO%20DE%202017.pdf'
    },
    {
        title: 'Decreto 945 de 2017 ',
        contents: 'Por el cual se modifica parcialmente el Reglamento Colombiano de Construcciones Sismo Resistentes NSR -10.',
        link: 'https://dapre.presidencia.gov.co/normativa/normativa/DECRETO%20945%20DEL%2005%20DE%20JUNIO%20DE%202017.pdf'
    },
    {
        title: 'Decreto 1077 de 2015 ',
        contents: 'Por medio del cual se expide el Decreto Único Reglamentario del Sector Vivienda, Ciudad Territorio.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=77216'
    },
    {
        title: 'DECRETO 926 de 2010',
        contents: 'Por el cual se establecen los requisitos de carácter técnico y científico para construcciones sismorresistentes NSR 10',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=39255'
    },
    {
        title: 'Decreto 2181 de 2006 ',
        contents: 'Por el cual se reglamentan parcialmente las disposiciones relativas a planes parciales contenidas en la Ley 388 de 1997 y se dictan otras disposiciones en materia urbanística.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=20809'
    },
    {
        title: 'Decreto 1538 de 2005',
        contents: 'Por el cual se reglamenta parcialmente la Ley 361 de 1997.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=16540'
    },
]